import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
module.exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") {
        return false;
    }
    return _instanceof(obj, Array) || Array.isArray(obj) || obj.length >= 0 && (_instanceof(obj.splice, Function) || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};
